<template>
<div class="auther_table_wrap">
  <el-table
   @expand-change='fn'
      :data="authors"
      border
      :row-key='fn3'
      :expand-row-keys='arr3'
      :row-style='obj0'
      style="width:95.2%;margin:0px auto;">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left"  inline class="demo-table-expand">
              <template>
                <el-table
                @expand-change='fn2'
                  border
                  :data="arr1"
                  :row-style='obj1'
                  style="width: 100%">
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-form label-position="left" inline class="demo-table-expand">
                        <el-table
                            :data="arr2"
                            border
                            :row-style='obj2'
                            style="width:100%;margin:0px auto;">
                          <el-table-column
                            prop="permission_id"
                            label="id"
                            width="100">
                          </el-table-column>
                          <el-table-column
                            prop="name"
                            label="权限点名称">
                          </el-table-column>
                          <el-table-column
                            prop="code"
                            label="链接权限点代码">
                          </el-table-column>
                          <el-table-column
                            prop="sequence"
                            label="排序号">
                          </el-table-column>
                          <el-table-column
                          label="操作">
                            <template slot-scope="scope">
                              <el-button
                                size="mini"
                                @click="fnPopShow(scope.row.permission_id,scope.row.parent_id,scope.row.name,scope.row.code,scope.row.type,scope.row.sequence)">编辑</el-button>
                              <el-button
                                size="mini"
                                type="danger"
                                @click="fnDelAuthor(scope.row.permission_id)">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table>


                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="permission_id"
                    label="id"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="二级菜单名称">
                  </el-table-column>
                  <el-table-column
                    prop="code"
                    label="链接权限点代码">
                  </el-table-column>
                  <el-table-column
                    prop="sequence"
                    label="排序号">
                  </el-table-column>
                  <el-table-column
                  label="操作">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        @click="fnPopShow(scope.row.permission_id,scope.row.parent_id,scope.row.name,scope.row.code,scope.row.type,scope.row.sequence)">编辑</el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        @click="fnDelAuthor(scope.row.permission_id)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>


          </el-form>
        </template>
      </el-table-column>
      <el-table-column
        prop="permission_id"
        label="id"
        width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="一级菜单名称">
      </el-table-column>
      <el-table-column
        prop="code"
        label="链接权限点代码">
      </el-table-column>
      <el-table-column
        prop="sequence"
        label="排序号">
      </el-table-column>
      <el-table-column
      label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="fnPopShow(scope.row.permission_id,scope.row.parent_id,scope.row.name,scope.row.code,scope.row.type,scope.row.sequence)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="fnDelAuthor(scope.row.permission_id)">删除</el-button>
        </template>
      </el-table-column>
   </el-table>

   <el-dialog title="编辑权限" :visible.sync="pop_show" append-to-body>
        <el-form :model="authorForm" status-icon :rules="rulesAuthorForm" ref="authorForm" label-width="100px">
          <el-form-item label="选择类型：" prop="type">
            <template>
              <el-radio-group v-model="authorForm.type">
                <el-radio :label="0" disabled>菜单</el-radio>
                <el-radio :label="1" disabled>权限点</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="父级：" prop="content_type">
            <el-select  disabled v-model="authorForm.content_type" size="small" :placeholder='aaa'>
              <el-option
                v-if='authorForm.type===0'
                label="无父级"
                value="0">
              </el-option>
              <el-option
                v-for="item in content_type_list"
                :label="item.name"
                :value="item.permission_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限名称：" prop="name">
            <el-input type="text" v-model="authorForm.name" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="权限链接：" prop="code">
            <el-input type="text" v-model="authorForm.code" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="排序号：" prop="sequence">
            <el-input type="text" v-model="authorForm.sequence" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="pop_show=false">取消</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'AuthorityTable',
  props:['authors'],
  data () {
    var validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('名称不能为空'));
        } else {
          callback()
        }
    };
    var validateCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('链接不能为空'));
        } else {
          callback()
        }
    };
    var validateSequence = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('序号不能为空!'));
        } else {
          callback()
        }
    };
    return {
      aaa: '',
    	pop_show:false,
    	content_type_list:[],
      edit_id:0,
      bool: true,
      arr1: [],
      arr2: [],
      arr3: [],
      obj0: {'background': '#FFDADC'},
      obj1: {'background': '#FFFCDE'},
      obj2: {'background': '#E7E4FF'},
      authorForm:{
        name:'',
        code:'',
        type: '',
        sequence: '',
        content_type: ''
      },
      rulesAuthorForm:{
        name: [
            { validator:validateName, trigger: 'blur' }
        ],
        sequence: [
            { validator:validateSequence, trigger: 'blur' }
        ],
        code: [
            { validator:validateCode, trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
  	fnPopShow(id,pid,name,code,type,sequence){
  		this.pop_show = true;
  		this.edit_id = id;
  		this.authorForm.name = name;
      this.authorForm.code = code;
      this.authorForm.type = type;
      this.authorForm.sequence = sequence;
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
        params:{
            type: 0,
          }
      })
      .then(dat=>{
          this.content_type_list = dat.data.data.permissions;

          if(pid == 0){
            this.aaa = '无父级'
            return
          }
          for(var i=0;i<this.content_type_list.length;i++){
            if(pid === this.content_type_list[i].permission_id){
              this.authorForm.content_type = this.content_type_list[i].permission_id
            }
          }
      }).catch(err=>{
         console.log(err.response);
      });
  	},
  	fnPopHide(){
  		this.pop_show = false;
	    that.author_ename = '';
	    that.author_type = 0;
  	},
  	submitForm(){
      let token = localStorage.token;
  		this.axios.put(cons.apis + '/v1_0/permissions/'+this.edit_id, {
              "name": this.authorForm.name,
              "code": this.authorForm.code,
              "type": this.authorForm.type,
        	    "sequence": this.authorForm.sequence,
              "parent_id": this.authorForm.content_type===''?0:this.authorForm.content_type
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        }).then(dat=>{
          // console.log(dat)
          if(dat.data.message.indexOf('already exists')>0){
             this.$message({
                type:'error',
                message:'用户名以存在！'
              });
             return
          }

          this.$message({
            type: 'success',
            message: '修改权限成功!'
          });
        	this.pop_show = false;
          this.resetForm('authorForm');
          this.$emit('fnResetTable');
          this.fn()
          this.fn2()
        }).catch(err=>{
        	console.log(err.response);
        })
  	},
  	fnDelAuthor(id){
        this.edit_id = id;
        let token = localStorage.token;
        this.$confirm('此操作将删除该权限, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.delete(cons.apis + '/v1_0/permissions/'+this.edit_id,{
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType:'json'
          }).then(dat=>{
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.$emit('fnResetTable');
          }).catch(err=>{
            if(err.response.status==400){
               this.$message({
                  type:'info',
                  message:'存在尚未删除的子目录'
                });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
  	},
    fnGetTypeList(){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/permission/content_types/', {
        headers: {
          'Authorization': 'JWT ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
          this.content_type_list = dat.data;
      }).catch(err=>{
         console.log(err.response);
      });
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    fn(row, expandedRows){
      // 展开一个
      this.arr3 = []
      this.arr3.push(row.permission_id)
      // console.log(row, expandedRows)
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            type: 0,
            order_by: 'id',
            parent_id: row.permission_id
          }
      })
      .then(dat=>{
          this.arr1 = dat.data.data.permissions;
      }).catch(err=>{
         console.log(err);
      });
    },
    fn2(row, expandedRows){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            type: 1,
            order_by: 'id',
            parent_id: row.permission_id
          }
      })
      .then(dat=>{
        // console.log(dat)
          this.arr2 = dat.data.data.permissions;
      }).catch(err=>{
         console.log(err);
      });
    },
    fn3(row){
      return row.permission_id
    }
  },
  mounted(){
    // this.fnGetTypeList();
  }
}
</script>

<style scope>
.el-table th,.el-table td{
  text-align:center;
}

</style>



// WEBPACK FOOTER //
// src/components/widget/PowerTable.vue